import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { beatBlipSubscriptionConsts } from '../../app/consts/beatBlipSubscriptionConsts';
// import { BehaviorSubject } from 'rxjs/BehaviorSubject'; 
import { ApiAiClient } from 'api-ai-javascript/es6/ApiAiClient';
import { Msg } from '../_models/msg';
@Injectable({  
  providedIn: 'root'
})
export class ChatService {
 
readonly token = beatBlipSubscriptionConsts.dialogflow.angularBot;
readonly client = new ApiAiClient({ accessToken: this.token });
conversation = new BehaviorSubject<Msg[]>([]);
 
constructor() {}
 
public talk(msg){
this.client.textRequest(msg)
.then( );
}

public update(msg: Msg) {
 
  return this.conversation.next([msg]);
}

public converse(msg: string) {
 
  const userMessage = new Msg(msg, 'user');
   
  this.update(userMessage);
  //return this.client.textRequest(msg);
  return this.client.textRequest(msg) 
 .then(res => { 
       const speech = res.result.fulfillment.speech; 
       const botMessage = new Msg(speech, 'bot'); 
    this.update(botMessage); 
  });
}

}